import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import {
  APPROVE_QUOTE_URL,
  get_headers,
  GET_QUOTES,
  REJECT_QUOTE_URL,
  UPLOAD_POP_URL,
  VIEW_QUOTE_PDF_URL
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';

export default {
  name: 'EntityInvoiceOverview',
  mixins: [alert_mixin, formatting_mixins],
  components: { GlobalTable },
  data: () => ({
    active_tab: 'Invoices',
    tabs: ['Invoices', 'Payment history'],
    invoices: [],
    preview_url: '',
    payment_history: [],
    headers: get_headers(),
    lead_id: null,
    application_id: null,
    selectedInvoice: null,
    approve_loading: false,
    quote_to_reject_id: null,
    rejection_reason: '',
    reject_loading: false,
  }),
  mounted() {
    this.lead_id = sessionStorage.getItem('lead_id'),
    this.application_id = sessionStorage.getItem('application_id');
    this.get_quotes();
  },
  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },

    get_quotes() {
  axios.get(GET_QUOTES, {
    headers: this.headers,
    params: {
      lead_id: this.lead_id,
      application_id: this.application_id
    }
  })
  .then(response => {
    const quotes = response.data.data;

    // Map and include balance
    this.invoices = quotes.map(q => ({
      id: q.id,
      quote_number: q.quote_number,
      date_issued: this.format_date(q.date_issued),
      date_valid_until: this.format_date(q.valid_until),
      date_created: this.format_date(q.date_created),
      status: q.quote_status.code,
      balance: q.balance // 🔹 Include balance here
    }));
  })
  .catch(error => {
    this.show_error("Error loading quotes: " + (error.response?.data?.message || error.message));
  });
},

    async open_preview_quote(quote_id) {
      await axios.get(VIEW_QUOTE_PDF_URL, {
        headers: this.headers,
        params: { quote_id: quote_id },
        responseType: 'blob',
      }).then(response => {

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        this.preview_url = url;

        this.selectedInvoice = this.invoices.find(inv => inv.id === quote_id) || null;
      })
        .catch(error => {
          this.show_error(
            "Error loading preview: " + (error.response?.data?.message || error.message)
          );
        });
    },

    selectInvoice(invoice) {
      this.selectedInvoice = invoice;
    },

    handle_file_selection(evt) {
      this.selected_files = Array.from(evt.target.files);

      if (this.selected_files.length === 1) {
        this.handle_file_preview(this.selected_files[0]);
      } else {
        this.preview_url = null;
        this.is_previewable = false;
      }
    },

    handle_file_preview(file) {
      const ext = file.name.split(".").pop().toLowerCase();
      this.is_previewable =
        ["pdf", "jpg", "jpeg", "png"].includes(ext);
      this.preview_url = URL.createObjectURL(file);
    },

    clear_file_selection() {
      if (this.preview_url) URL.revokeObjectURL(this.preview_url);
      this.preview_url = null;
      this.is_previewable = false;
      this.selected_files = [];
    },

    async approve_quote(quote_id) {
      if (!quote_id) return this.show_error("Quote ID is missing.");
      this.approve_loading = true;

      try {
        const response = await axios.post(
          APPROVE_QUOTE_URL,
          { quote_id },
          { headers: this.headers }
        );

        if (response.data.status === 'success') {
          this.show_success("Quote approved successfully.");
          this.get_quotes();
        } else {
          this.show_error(response.data.message || "Approval failed.");
        }
      } catch (error) {
        const msg = error.response?.data?.message || error.message;
        this.show_error(msg);
      } finally {
        this.approve_loading = false;
        this.preview_url = null;
        this.selectedInvoice = null;
      }
    },


    async submit_rejection() {
      if (!this.quote_to_reject_id || !this.rejection_reason.trim()) {
        return this.show_error("Quote ID and reason are required.");
      }


      this.reject_loading = true;

      try {
        const response = await axios.post(
          REJECT_QUOTE_URL,
          {
            quote_id: this.quote_to_reject_id,
            reason: this.rejection_reason.trim(),
          },
          {
            headers: this.headers,
          }
        );

        if (response.data.status === 'success') {
          this.show_success("Quote rejected successfully.");
          this.get_quotes();
        } else {
          this.show_error(response.data.message || "Rejection failed.");
        }
      } catch (error) {
        const msg = error.response?.data?.message || error.message;
        this.show_error(msg);
      } finally {
        this.reject_loading = false;
        this.rejection_reason = '';
        this.quote_to_reject_id = null;
      }
    },

    open_reject_modal(quote_id) {
      this.quote_to_reject_id = quote_id;
      this.rejection_reason = '';
    },






    async submit_payment_proof() {
      this.lead_id = sessionStorage.getItem("lead_id");

      if (!this.selected_files.length || !this.lead_id) {
        return this.show_error(
          "Please select file(s) and make sure a lead ID is present in session."
        );
      }

      const form_data = new FormData();
      form_data.append("lead_id", this.lead_id);

      this.selected_files.forEach((file) =>
        form_data.append("document", file)
      );

      this.upload_loading = true;
      try {
        const { data } = await axios.post(UPLOAD_POP_URL, form_data, {
          headers: {
            ...this.headers,
            "Content-Type": "multipart/form-data",
          },
        });

        if (data.status === "success") {
          this.show_success(
            `Uploaded ${this.selected_files.length} file(s) successfully.`
          );
          this.clear_file_selection();
        } else {
          this.show_error(data.message || "Upload failed");
        }
      } catch (err) {
        const msg =
          err.response?.data?.message ||
          err.response?.data?.detail ||
          err.message;
        this.show_error(msg);
      } finally {
        this.upload_loading = false;
      }
    }
  }
}
